import { Box, Container, Grid, Paper, Typography, useTheme, alpha } from '@mui/material';
import WifiIcon from '@mui/icons-material/Wifi';
import RouterIcon from '@mui/icons-material/Router';
import TvIcon from '@mui/icons-material/Tv';
import SettingsInputAntennaIcon from '@mui/icons-material/SettingsInputAntenna';
import HubIcon from '@mui/icons-material/Hub';
import SectionHeading from '../ui/SectionHeading';
import Reveal from '../ui/Reveal';
import { moduleColors } from '../../theme';

const groups = [
  {
    title: 'Internet',
    icon: <WifiIcon fontSize="large" />,
    color: moduleColors.core,
    items: ['Radius Manager', 'DMA', 'MikroTik', 'DOCSIS CMTS'],
  },
  {
    title: 'SolvendaRadius',
    icon: <RouterIcon fontSize="large" />,
    color: moduleColors.radius,
    items: ['FreeRADIUS', 'MikroTik / NAS', 'Speed profiles', 'DNS servers'],
  },
  {
    title: 'IPTV',
    icon: <TvIcon fontSize="large" />,
    color: '#E5749B',
    items: ['Stalker Portal', 'Xtream Codes', 'Ministra', 'Flussonic'],
  },
  {
    title: 'DVB-C',
    icon: <SettingsInputAntennaIcon fontSize="large" />,
    color: '#5AA9E6',
    items: ['TVCAS', 'Conax', 'DVB-C equipment'],
  },
  {
    title: 'OLT / FTTH',
    icon: <HubIcon fontSize="large" />,
    color: moduleColors.olt,
    items: ['ZTE C320', 'ZTE C300', 'ZTE C600', 'Huawei (soon)'],
  },
];

const CompatibilitySection = () => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  return (
    <Box sx={{ py: { xs: 8, md: 12 }, bgcolor: 'background.paper' }}>
      <Container>
        <SectionHeading
          overline="Plays well with your stack"
          title="Integrates with what you already run"
          subtitle="Solvenda connects to industry-standard platforms and network gear — no rip-and-replace."
        />
        <Grid container spacing={3} justifyContent="center">
          {groups.map((g, i) => (
            <Grid item xs={12} sm={6} md={4} lg={2.4} key={g.title}>
              <Reveal delay={i * 50} sx={{ height: '100%' }}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 3,
                    height: '100%',
                    textAlign: 'center',
                    borderRadius: 3,
                    border: '1px solid',
                    borderColor: 'divider',
                    transition: 'transform 0.3s ease, border-color 0.3s ease',
                    '&:hover': { transform: 'translateY(-8px)', borderColor: alpha(g.color, 0.5) },
                  }}
                >
                  <Box
                    sx={{
                      width: 64,
                      height: 64,
                      mx: 'auto',
                      mb: 2,
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: g.color,
                      bgcolor: alpha(g.color, isDark ? 0.16 : 0.12),
                    }}
                  >
                    {g.icon}
                  </Box>
                  <Typography variant="h6" component="h3" sx={{ mb: 1.5 }}>
                    {g.title}
                  </Typography>
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>
                    {g.items.map((item) => (
                      <Typography key={item} variant="body2" color="text.secondary">
                        {item}
                      </Typography>
                    ))}
                  </Box>
                </Paper>
              </Reveal>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default CompatibilitySection;
